import { CanAccess } from '@modules/common/components/CanAccess';
import { EditRounded, EmailRounded } from '@mui/icons-material';
import { LoadingButton, LoadingButtonProps } from '@mui/lab';
import { Box, Tooltip } from '@mui/material';
import { PermissionOperation, PermissionResource } from 'generated/graphql';

interface SubscribeFeedbackButtonProps {
  onClick: () => void;
  label: string;
  isSubscribed: boolean;
  isDisabled: boolean;
  isLoading: boolean;
  tooltipText?: string;
  variant?: LoadingButtonProps['variant'];
}

const SubscribeButton = ({
  onClick,
  label,
  isSubscribed,
  isDisabled,
  isLoading,
  tooltipText = '',
  variant,
}: SubscribeFeedbackButtonProps) => {
  const defaultVariant = isSubscribed ? 'outlined' : 'contained';

  return (
    <CanAccess
      resource={PermissionResource.OutboundIntegration}
      operation={PermissionOperation.Write}
    >
      <Tooltip title={tooltipText} placement="bottom" disableInteractive>
        <Box component="span">
          <LoadingButton
            loading={isLoading}
            variant={variant ?? defaultVariant}
            startIcon={isSubscribed ? <></> : <EmailRounded />}
            endIcon={isSubscribed ? <EditRounded /> : <></>}
            onClick={onClick}
            disabled={isDisabled}
          >
            {isSubscribed ? '✓ Subscribed' : `${label}`}
          </LoadingButton>
        </Box>
      </Tooltip>
    </CanAccess>
  );
};

export default SubscribeButton;
